import { useCallback } from 'react';

import { AccessTags, getAccessTags, getPageInfoFromRouteConfig, PageTags, useAnalytics } from '../../analytics';
import { FooterAnalyticsTags } from './types';
interface FooterAnalytics {
  page: string;
  pageName?: string;
  getTrackingTags?: () => Partial<AccessTags & PageTags>;
}
interface UseContentAnalyticsReturnType {
  trackFooterElementClicked: (eventProps: FooterAnalytics) => void;
}
interface DefaultTrackingTags extends Partial<AccessTags & PageTags> {}

const getDefaultTrackingTags = async (defaultPageName: string): Promise<DefaultTrackingTags> => {
  const { pathname } = window.location;
  const pageInfo = defaultPageName
    ? { pageName: defaultPageName, section: '', subsection: '' }
    : getPageInfoFromRouteConfig(pathname);
  const { pageName, section, subsection } = pageInfo;
  const accessTags = await getAccessTags(pageInfo.requiredModules);
  return {
    access: accessTags.access,
    pageName,
    section,
    subsection,
  };
};

export const useContentAnalytics = (): UseContentAnalyticsReturnType => {
  const { track } = useAnalytics();

  const trackFooterElementClicked = useCallback(
    async (eventProps: FooterAnalytics) => {
      const { page, pageName: defaultPageName, getTrackingTags } = eventProps;
      const { search } = window.location;
      const { access, pageName, section, subsection, ...rest } =
        getTrackingTags?.() ?? (await getDefaultTrackingTags(defaultPageName));

      const queryString = search;
      const urlParams = new URLSearchParams(queryString);
      const locationId = urlParams.get('country');
      const itemGroup = urlParams.get('itemGroup');
      const marketInfoAnalytics = locationId && itemGroup ? { locationId, itemGroup } : '';

      track<FooterAnalyticsTags>('Page Element Clicked', {
        access,
        elementType: 'Footer',
        elementName: page,
        pageName,
        section,
        subsection,
        ...marketInfoAnalytics,
        ...rest,
      });
    },
    [track]
  );
  return {
    trackFooterElementClicked,
  };
};
